'use client';

import { getFirebaseAuth, popupResolver } from '@/lib/firebase';
import {
  signOut,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink
} from 'firebase/auth';
import { OAuthProvider } from 'firebase/auth/web-extension';


const actionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be in the authorized domains list in the Firebase Console.
  url:
    typeof window === "undefined"
      ? "https://public.app/auth/login"
      : window.location.origin + "/auth/login",
  // This must be true.
  handleCodeInApp: true,
  iOS: {
    bundleId: "com.nis.public",
  },
  android: {
    packageName: "com.cardfeed.video_public",
    installApp: true,
  },
  dynamicLinkDomain: "link.publicapp.co.in",
};

export async function sendMagicLink(email: string) {
  // const actionCodeSettings = {
  //   url: `${window.location.origin}/complete-signin`, // redirect after login
  //   handleCodeInApp: true,
  // };
  await sendSignInLinkToEmail(getFirebaseAuth(), email, actionCodeSettings);
  window.localStorage.setItem('emailForSignIn', email);
}

export async function completeMagicLinkLogin() {
  const auth = getFirebaseAuth();
  if (!isSignInWithEmailLink(auth, window.location.href)) {
    return false
  }

  const email = window.localStorage.getItem('emailForSignIn');
  if (!email) {
    throw new Error('No email found in local storage for magic link sign-in.');
  }

  try {
    await signInWithEmailLink(auth, email, window.location.href);
    window.localStorage.removeItem('emailForSignIn');
    return 'Sign-in successful!';
  } catch (error: any) {
    if (error.code === 'auth/invalid-action-code') {
      throw new Error('The sign-in link is invalid or expired.');
    }
    if (error.code === 'auth/user-disabled') {
      throw new Error('This user account has been disabled.');
    }
    if (error.code === 'auth/user-not-found') {
      throw new Error('No user found for this email.');
    }
    throw new Error('Failed to complete sign-in with magic link.');
  }
}


export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  return await signInWithPopup(getFirebaseAuth(), provider, popupResolver);
};

export const signInWithFacebook = async () => {
  const provider = new FacebookAuthProvider();
  return await signInWithPopup(getFirebaseAuth(), provider, popupResolver);
};

export const signInWithEmail = async (email: string, password: string) => {
  return await signInWithEmailAndPassword(getFirebaseAuth(), email, password);
};

export const signUpWithEmail = async (email: string, password: string) => {
  return await createUserWithEmailAndPassword(getFirebaseAuth(), email, password);
};

export async function signInWithApple() {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');
  return await signInWithPopup(getFirebaseAuth(), provider, popupResolver);
}

export const signOutUser = async () => {
  try {
    return await signOut(getFirebaseAuth());
  } catch (error) {
    console.error('Error signing out:', error);
    return false
  }
}